import { QRCode, type QRCodeVariant } from "Components/Shared/QRCode";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  paymentDescriptor: string;
  size?: number;
  qrVariant?: QRCodeVariant;
  shareButtonLabel?: string;
};

export const InvoiceQRCode = ({
  paymentDescriptor,
  size,
  qrVariant,
  shareButtonLabel,
}: Props) => {
  const { t } = useResource();

  return (
    <QRCode
      content={paymentDescriptor}
      size={size}
      downloadFileName={t(Resources.Components.Invoice.PaymentData)}
      variant={qrVariant}
      shareButtonLabel={shareButtonLabel}
    />
  );
};
